<template>
  <span>
    <v-card>
      <v-card-text>
        <v-btn icon tag="a" :href="`http://tesseract-ics.herokuapp.com/api/class/${this.$route.params.id}/download?file_location=${file}&token=${this.$store.getters.GET_TOKEN}`" download>
          <v-icon color="blue">file_download</v-icon>
        </v-btn>
        <span>{{file}}</span>
      </v-card-text>
    </v-card>
    <v-divider></v-divider>
  </span>
</template>

<script>
import axios from 'axios'
export default {
  props: ['file']
}
</script>



// WEBPACK FOOTER //
// src/components/Student/Classroom/File.vue